<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
let customerId = window.localStorage.getItem("customerId")
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "supplier",
      key: "id",
      kv: "",
      url: {},
      items: [
        { label: "项目合同信息", type: "header" },
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
          rules: [{ required: false, trigger: "blur" }],
          onAddress: this.addres,
          onCancel: this.cancel,
        },
        {
          label: "合同名称",
          name: "name",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur", message: "合同名称不能为空" }],
        },
        {
          label: Number(customerId) == 0 ? '客户' : '供应商',
          name: "supplierId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: Number(customerId) == 0 ? '客户不能为空' : '供应商不能为空',
              trigger: "blur",
              type: "number",
            },
          ],
          selected: 0,
        },
        {
          label: "类型",
          name: "type",
          type: "select",
          width: "400px",
          value: 2,
          dropList: [
            {
              value: 1,
              name: "购销合同",
            },
            {
              value: 2,
              name: "服务合同",
            },
            {
              value: 3,
              name: "维保合同",
            },
          ],
          onChange: this.onisParent,
        },
        { label: "合同起始日", name: "contractStartTime", value: "", type: "date" },
        { label: "合同终止日", name: "contractEndTime", value: "", type: "date" },
        { label: "签订日期", name: "moveStart", value: "", type: "date" },
        { label: "预计交付日期", name: "moveEnd", value: "", type: "date" },
        {
          label: "合同总金额(元)",
          name: "totalMoney",
          value: 0,
          type: "number",
          width: "400px",
          min: 0,
          formatter: (value) => `¥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          parser: (value) => value.replace(/\¥\s?|(,*)/g, ""),
        },
        {
          label: "合同备注",
          name: "remark",
          value: "",
          type: "input",
          width: "400px",
        },

        {
          label: "招标定稿文件",
          name: "biddingDocumentUrl",
          value: "",
          type: "documents",
          desc: "",
        },
        {
          label: "合同文件",
          name: "pdfpath",
          value: "",
          type: "documents",
          desc: "",
        },
        {
          label: "验收文件",
          name: "ar",
          value: "",
          type: "documents",
          width: "400px",
        },
      ],
      forms: {},
    };
  },
  created() {
    this.onisParent(2);
    this.forms.projectId = localStorage.getItem("projectId");
    this.loaduserData();
    let query = this.$route.query;
    if (query.action === "edit") {
      this.forms.id = query.kv;
      this.kv = query.kv;
      this.initData();
    }
  },
  mounted() {},
  methods: {
    onisParent(val) {
      if (val == 1) {
        this.items[this.getItemIndex("moveStart")].type = "date";
        this.items[this.getItemIndex("moveEnd")].type = "date";
        this.items[this.getItemIndex("contractStartTime")].type = "kong";
        this.items[this.getItemIndex("contractEndTime")].type = "kong";
      }
      if (val == 2 || val == 3) {
        this.items[this.getItemIndex("contractStartTime")].type = "date";
        this.items[this.getItemIndex("contractEndTime")].type = "date";
        this.items[this.getItemIndex("moveStart")].type = "kong";
        this.items[this.getItemIndex("moveEnd")].type = "kong";
      }
    },
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      $utils.api.load("/admin/system/supplier/list").then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.supplierName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "supplierId") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/contract/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          $utils.api
            .load(`/admin/system/contract`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
      // this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     if (this.forms.id) {
      //       $utils.api
      //         .load(`/admin/system/contract`, q, "POST")
      //         .then((res) => {
      //           this.sloading = false;
      //           if (res.status) {
      //             $utils.toast.success("保存成功");
      //             $utils.url.go(-1);
      //           }
      //         })
      //         .catch((e) => {
      //           this.sloading = false;
      //           $utils.toast.error("保存异常" + e.message);
      //         });
      //     } else {
      //       $utils.api
      //         .load(`/admin/system/supplier/edit`, q, "POST")
      //         .then((res) => {
      //           this.sloading = false;
      //           if (res.status) {
      //             $utils.toast.success("保存成功");
      //             $utils.url.go(-1);
      //           }
      //         })
      //         .catch((e) => {
      //           this.sloading = false;
      //           $utils.toast.error("保存异常" + e.message);
      //         });
      //     }
      //   }
      // });
    },
  },
};
</script>
